import { PlatformMessage } from '@reachmedianetwork/post-message-client-rds-api';
import { PlayerPmc } from '../PlayerPmc';

export interface NtpInterface {
    /**
     * Configure and enable NTP service
     * @throws {@link Platform.NotImplementedError}
     * Thrown if NTP updating is not supported by current version of the platform.
     */
    enableNtp(server: string, interval: number): Promise<void>;

    /**
     * Release control of NTP back to the OS
     */
    disableNtp(): Promise<void>;
}

export interface NtpClockSkewInterface extends NtpInterface {
    /**
     * Skew the NTP Time by some amount
     * @deprecated This is hard to implement on most platforms and is rarely used.
     * @todo Figure out time unit (i.e. seconds or milliseconds)
     */
    setNtpClockSkew(skewAmount: number): Promise<void>;
}

export function supportsNtp(platform: unknown): platform is NtpInterface {
    if (platform instanceof PlayerPmc) {
        return (
            platform.supportsMessage(PlatformMessage.NtpEnable) &&
            platform.supportsMessage(PlatformMessage.NtpDisable)
        );
    }
    return platform instanceof Object && 'enableNtp' in platform && 'disableNtp' in platform;
}

export function supportsNtpClockSkew(platform: unknown): platform is NtpClockSkewInterface {
    return platform instanceof Object && 'setNtpClockSkew' in platform && supportsNtp(platform);
}
